module.exports = __webpack_public_path__ + "img/remove-product.fff35d48.png";